import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icons } from 'app/shared/utils/icons';

@Component({
  standalone: false,
  selector: 'ti-file-upload-tag',
  templateUrl: './file-upload-tag.component.html',
  styleUrls: ['./file-upload-tag.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadTagComponent implements OnInit {
  @Input() isEditable: boolean = false;
  @Input() isLoading: boolean = false;
  // @Input() doc: any; // TODO: change type of doc
  @Input() id: number;
  @Input() name: string;
  @Input() format: string;
  @Output() onRemove: EventEmitter<number> = new EventEmitter<number>();

  public iconType: string;
  public iconColor: string;

  public remove(): void {
    this.onRemove.emit(this.id);
  }

  private getIconColor(fileName: string): string {
    return;
  }

  public ngOnInit(): void {
    this.iconType = Icons.getClassByFileType(this.format, false);
    this.iconColor = Icons.getColorByFileType(this.name);
  }
}
